"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./TRCHeader.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/*
 * @deprecated since 10/29/2020
 * Will be removed soon
 */
function TRCHeader(props) {
  console.warn("TRCHeader is a depricated component!");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "TRCHeader"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "share",
    onClick: props.onClickShare
  }, "Share"));
}

var _default = TRCHeader;
exports.default = _default;